"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class GroupRolePermission {
  static thaw(groupRolePermissionObj) {
    if (groupRolePermissionObj == null) return null;
    const groupRolePermission = new GroupRolePermission();
    if (groupRolePermissionObj.id != null) groupRolePermission.setId(groupRolePermissionObj.id);
    if (groupRolePermissionObj.permissionType != null) groupRolePermission.setPermissionType(groupRolePermissionObj.permissionType);
    if (groupRolePermissionObj.roleId != null) groupRolePermission.setRoleId(groupRolePermissionObj.roleId);
    if (groupRolePermissionObj.groupId != null) groupRolePermission.setGroupId(groupRolePermissionObj.groupId);
    if (groupRolePermissionObj.role != null) groupRolePermission.setRole(_.GroupRole.thaw(groupRolePermissionObj.role));
    return groupRolePermission;
  }

  static thawList(groupRolePermissionObjList) {
    if (groupRolePermissionObjList == null) return [];
    var groupRolePermissions = [];

    for (var i = 0; i < groupRolePermissionObjList.length; i++) {
      groupRolePermissions.push(GroupRolePermission.thaw(groupRolePermissionObjList[i]));
    }

    return groupRolePermissions;
  }

  static freeze(groupRolePermission) {
    if (groupRolePermission == null) return null;
    var groupRolePermissionObj = {};
    if (groupRolePermission.getId() != null) groupRolePermissionObj.id = groupRolePermission.getId();
    if (groupRolePermission.getPermissionType() != null) groupRolePermissionObj.permissionType = groupRolePermission.getPermissionType();
    if (groupRolePermission.getRoleId() != null) groupRolePermissionObj.roleId = groupRolePermission.getRoleId();
    if (groupRolePermission.getGroupId() != null) groupRolePermissionObj.groupId = groupRolePermission.getGroupId();
    if (groupRolePermission.getRole() != null) groupRolePermissionObj.role = _.GroupRole.freeze(groupRolePermission.getRole());
    return groupRolePermissionObj;
  }

  static freezeList(groupRolePermissions) {
    if (groupRolePermissions == null) return [];
    var groupRolePermissionObjList = [];

    for (var i = 0; i < groupRolePermissions.length; i++) {
      groupRolePermissionObjList.push(GroupRolePermission.freeze(groupRolePermissions[i]));
    }

    return groupRolePermissionObjList;
  }

  constructor() {
    this.setId(null);
    this.setPermissionType(null);
    this.setRoleId(null);
    this.setGroupId(null);
    this.setRole(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setPermissionType(permissionType) {
    this.permissionType = permissionType;
  }

  setRoleId(roleId) {
    this.roleId = roleId;
  }

  setGroupId(groupId) {
    this.groupId = groupId;
  }

  setRole(role) {
    this.role = role;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getPermissionType() {
    return this.permissionType;
  }

  getRoleId() {
    return this.roleId;
  }

  getGroupId() {
    return this.groupId;
  }

  getRole() {
    return this.role;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = GroupRolePermission;